<template>
    <ListModule
        :label="$t('components.smart.featuredPositions.label')"
        :data="data()"
        :to="jobsURL()"
        :is-loading="loading()"
    />
</template>

<script>
import defaultLogo from '~/assets/img/DefaultLogo.png';
import dateToString from '~/utils/dateToString';

const FP_LIMIT = 5;

export default {
    data() {
        return {
            canGetPostings: false,
            shuffledList: [],
        };
    },
    computed: {
        featuredPostings() {
            return this.canGetPostings
                ? this.$interfaces.posting.get({
                      reactive: true,
                      mode: 'featured',
                  })
                : { loading: true };
        },
        shuffledData() {
            !this.shuffledList.length && this.shuffle(this.featuredPostings.data);
            return this.shuffledList;
        },
    },
    methods: {
        // Logic: Randomly picks one position per company.
        // If positions from the same company appear, they will be appended at the end of the list.
        // Companies with lots featured have a higher chance of showing first.
        shuffle(data) {
            if (!data || !data.length) return [];

            const newData = [];
            const rest = [];
            const compIDsCovered = [];

            while (data.length) {
                const randIndex = Math.floor(Math.random() * data.length);

                if (compIDsCovered.includes(data[randIndex].companyId)) {
                    rest.push(data[randIndex]);
                } else {
                    newData.push(data[randIndex]);
                    compIDsCovered.push(data[randIndex].companyId);
                }

                data.splice(randIndex, 1);
            }

            this.shuffledList = newData.concat(rest);
        },
        data() {
            return (this.shuffledData || []).slice(0, FP_LIMIT).map(value => ({
                ...value,
                id: value.id,
                header: value.title,
                subheader: value.shortLocation || value.country || value.address,
                subtitle: value.deadline
                    ? this.$t('shared.postingModule.postCard.deadline').concat(
                          ': ',
                          dateToString(value.deadline)
                      )
                    : '',
                image: value.companyLogo || defaultLogo,
            }));
        },
        loading() {
            return this.featuredPostings.loading;
        },
        error() {
            return this.featuredPostings.error;
        },
        jobsURL: function() {
            return this.$URLS.jobDetail;
        },
    },
    mounted() {
        this.$interfaces.user.me.get().then(res => {
            this.canGetPostings = true;
        });
    },
};
</script>

<style scoped></style>
